/* eslint-disable max-len */
const RegExpForEmailValidation = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
export default RegExpForEmailValidation;
export const confirmEmailValidation = (email, confirmEmail, message = 'Email e confirmar email são diferentes') => {
    if (email !== confirmEmail) {
        return message;
    }
    return undefined;
};
